import CryptoJS from "crypto-js";

const key = "HRj96Hlo7QQpgRWgMlRcHRj96Hlo7QQp";

export const encrypt = (value) => CryptoJS.AES.encrypt(value, key).toString();

export const decrypt = (cipher) => {
    const bytes = CryptoJS.AES.decrypt(cipher, key);
    return bytes.toString(CryptoJS.enc.Utf8);
}